import React from "react";
import PropTypes from "prop-types";

export default function WarningInfoSVG(props) {
  const {
    styles: {
      height,
      width,
      fill
    }
  } = props;
  return (
    <svg
      id={props.id || ''}
      className={props.className || ''}
      height={height || '16px'}
      width={width || '10px'}
      fill="#ffffff"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 10 16"
    >
      <title>Icon/Alert/Error</title>
      <g id="General-errors" stroke="none" strokeWidth="1" fill={fill || '#ffffff'} fillRule="evenodd">
        <g id="Error-8---section-and-row-error-_x5B_Web_x5D_" transform="translate(-71.000000, -258.000000)">
          <g id="Group-4" transform="translate(64.000000, 246.000000)">
            <g id="Icon_x2F_Alert_x2F_Warning" transform="translate(4.000000, 12.000000)">
              <polygon id="warning" points="7.5,15.4 12.8,6.3 8.5,6.3 8.5,0.4 3.2,9.6 7.5,9.6 7.5,9.6 7.5,10.7"/>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

WarningInfoSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};

WarningInfoSVG.defaultProps = {
  styles: {
    fill: "#ffffff",
    height: "32px",
    width: "32px"
  }
};
